import { render, staticRenderFns } from "./TabTwo.vue?vue&type=template&id=58d4b72e&scoped=true&"
import script from "./TabTwo.vue?vue&type=script&lang=js&"
export * from "./TabTwo.vue?vue&type=script&lang=js&"
import style0 from "./TabTwo.vue?vue&type=style&index=0&id=58d4b72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4b72e",
  null
  
)

export default component.exports